import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

type SeverityOptions = 'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' | null | undefined;

@Component({
    selector: 'confirmation-button',
    templateUrl: './confirmation-button.component.html',
    styleUrls: ['./confirmation-button.component.scss'],
    standalone: false
})
export class ConfirmationButtonComponent implements OnInit {
    isDisabled: boolean = false;
    confirming: boolean;

    @Input() size?: 'sm' | null | undefined;

    @Input() iconsOnly: boolean = false;

    @Input() set disabled(val: boolean) {
        this.isDisabled = val;

        if (this.confirming)
            this.DoCancel();
    }

    @Input() actionText: string = 'Delete';
    @Input() confirmText: string = 'Delete';
    @Input() cancelText: string = 'Cancel';

    @Input() actionIcon: string = 'pi pi-times';
    @Input() confirmIcon: string = 'pi pi-times';
    @Input() cancelIcon: string = '';

    @Input() actionSeverity: SeverityOptions = 'danger';
    @Input() confirmSeverity: SeverityOptions = 'danger';
    @Input() cancelSeverity: SeverityOptions = 'secondary';
    @Input() working: boolean = false;

    @Input() questionText: string = '';

    @Output() actionConfirmed: EventEmitter<any>;

    constructor() {
        this.actionConfirmed = new EventEmitter();
    }

    ngOnInit(): void {
        this.confirming = false;
    }

    DoCancel(): void {
        this.confirming = false;
    }

    DoAction(): void {
        if (!this.confirming) {
            this.confirming = true;
        }
        else {
            this.actionConfirmed.emit();
            this.confirming = false;
        }
    }

    DisplayIcon(): string {
        if (this.working)
            return 'pi pi-spin pi-spinner';
        else if (this.confirming)
            return this.confirmIcon;
        else
            return this.actionIcon;
    }
}
